<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_SalesReport002
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapMutations, mapState } from 'vuex';
import store from '@/store';
import APP_SalesReport002_store from '@/views/mobile/app_sales_report/APP_SalesReport002/store';

/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';
import helpers from '@/utils/helpers';
/**
 * Define component chat for show page chat
 */
var APP_SalesReport002 = {
    template: template,
    components: {},
    props: {
        typeSelected: {
            type: Number,
            default: 1
        }
    },
    beforeCreate() {
        if (!store.hasModule('APP_SalesReport002')) {
            store.registerModule('APP_SalesReport002', APP_SalesReport002_store);
        }
    },
    created() {
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
    },
    mounted() {
        this.setHeader(this.header);
    },
    unmounted() {
        this.setHeader();
    },
    data() {
        return {
            screenId: 'APP_SalesReport002',
            liftedIndex: null,
            holdTimer: null,
            deleteTimer: null,
            selectedIndex: null
        };
    },
    emits: ['emitHideDetail'],
    watch: {
        typeSelected(newVal) {
            this.data.type = newVal;
            this.changeType();
        }
    },
    computed: {
        // ...mapState('app', ['user', 'zoom', 'isShowLeftMenu', 'header']),
        ...mapState('APP_SalesReport002', ['optionGroup', 'data', 'paginationData']),
        header() {
            const data = {
                title: '業務日報登録',
                topButtons: []
            };
            return data;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapMutations('APP_SalesReport002', ['resetFormData']),
        //     ...mapActions('APP_SalesReport002', ['getScreenData', 'saveRead', 'storeChangeStatus', 'readAllMessage']),
        changeCurrentPage() {},
        addNewSchedule() {
            this.data.purchasing_people.push({
                no: Date.now(),
                start_date: '',
                person_in_charge: '',
                filename: '',
                file: '',
                note: '',
                showImage: false,
                disable: { start_date: false, person_in_charge: false, note: false }
            });
        },
        disableField(item, key) {
            if (item[key]) {
                item.disable[key] = true;
            }
        },
        renderNo(index) {
            return index + 1 < 10 ? '0' + (index + 1) : index + 1;
        },
        changeType() {
            this.resetFormData(this.data.type);
        },
        hideDetail() {
            this.$emit('emitHideDetail');
        },
        drafSubmit() {},
        submit() {},

        openFile(id, index) {
            document.querySelector('#' + id + index).value = '';
            document.querySelector('#' + id + index).click();
        },
        changeFileReport(event) {
            const file = event.target.files[0];
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#reporting_file').value = '';
                return;
            }
            if (file.type != 'application/pdf') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E004,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileReport();
                        }
                    }
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileReport();
                        }
                    }
                });
                return;
            }
            const filename = file.name;
            this.data.reporting_filename = filename;
            this.data.reporting_file = file;
        },
        deleteFile(item) {
            item.filename = '';
            item.file = '';
        },
        deleteFileReport() {
            this.data.reporting_filename = '';
            this.reporting_file = '';
        },
        showImageCard(item) {
            item.showImage = !item.showImage;
        },
        changeFile(event, item, index) {
            const file = event.target.files[0];
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#business_card' + index).value = '';
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.filename = '';
                            item.file = '';
                        }
                    }
                });
                return;
            }
            const filename = file.name;
            item.filename = filename;
            item.file = file;
        },
        deleteItemTable(index_no) {
            if (this.data.purchasing_people.length == 1) return;
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: 'いいえ',
                okText: 'はい',
                callback: (ok) => {
                    if (ok) {
                        if (this.selectedIndex !== null) {
                            this.data.purchasing_people = this.data.purchasing_people.filter((item) => item.no != index_no);
                            this.selectedIndex = null;
                        }
                        this.liftedIndex = null;
                    }
                },
                callbackCancel: (ok) => {
                    if (ok) {
                        this.selectedIndex = null;
                        this.liftedIndex = null;
                    }
                }
            });
        },
        startHold(e, index, itemNo) {
            const tag = e.target.tagName.toLowerCase();
            if (['input', 'select', 'textarea', 'button', 'label'].includes(tag)) {
                return true;
            }
            this.holdTimer = setTimeout(() => {
                this.liftedIndex = index;
            }, 300);

            this.deleteTimer = setTimeout(() => {
                this.selectedIndex = index;
                this.deleteItemTable(itemNo);
            }, 800);
        },
        cancelHold() {
            clearTimeout(this.holdTimer);
            clearTimeout(this.deleteTimer);
            this.liftedIndex = null;
        }
    }
};
export default APP_SalesReport002;
</script>
